import { render, staticRenderFns } from "./ObjectCardComment.vue?vue&type=template&id=22c033f6&scoped=true&"
import script from "./ObjectCardComment.vue?vue&type=script&lang=js&"
export * from "./ObjectCardComment.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardComment.vue?vue&type=style&index=0&id=22c033f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c033f6",
  null
  
)

export default component.exports